import { render, staticRenderFns } from "./cabinetMaintenance.vue?vue&type=template&id=5cfc1ab1&scoped=true"
import script from "./cabinetMaintenance.vue?vue&type=script&lang=js"
export * from "./cabinetMaintenance.vue?vue&type=script&lang=js"
import style0 from "./cabinetMaintenance.vue?vue&type=style&index=0&id=5cfc1ab1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc1ab1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cfc1ab1')) {
      api.createRecord('5cfc1ab1', component.options)
    } else {
      api.reload('5cfc1ab1', component.options)
    }
    module.hot.accept("./cabinetMaintenance.vue?vue&type=template&id=5cfc1ab1&scoped=true", function () {
      api.rerender('5cfc1ab1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/smartCabinet/cabinetMaintenance.vue"
export default component.exports